import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import Modal from '../../components/confirmationModel/ConfirmationModel';
import ProfileForm from '../../components/ProfileForm/ProfileForm';
import OrderHistory from '../../components/OrderHistory/OrderHistory';
import './ProfilePage.css';

const ProfilePage = () => {
    const { logout } = useAuth(); 
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('profile');

    return (
        <>
            <div className="profile-container">
                <div className="profile-card">
                    <div className="profile-tabs">
                        <button 
                            className={`tab-button ${activeTab === 'profile' ? 'active' : ''}`}
                            onClick={() => setActiveTab('profile')}
                        >
                            Edit Profil
                        </button>
                        <button 
                            className={`tab-button ${activeTab === 'orders' ? 'active' : ''}`}
                            onClick={() => setActiveTab('orders')}
                        >
                            Riwayat Pesanan
                        </button>
                    </div>
                    {activeTab === 'profile' && <ProfileForm onLogoutClick={() => setIsModalOpen(true)} />}

                    {activeTab === 'orders' && <OrderHistory />}
                </div>
            </div>

            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={logout}
                title="Konfirmasi Logout"
                confirmText="Ya, Logout"
            >
                Apakah Anda yakin ingin keluar dari akun Anda?
            </Modal>
        </>
    );
};

export default ProfilePage;